import React from "react";
import ApprovalList from "./ApprovalList";

// 休み申請 承認ページ（管理者）。共通の ApprovalList に列/カード/APIを渡すだけの薄い実装。
// 承認するとバックエンドが該当日へ日付例外(休み)を自動生成し、却下すると自動生成分を削除する。
const TYPE_LABEL = { paid: "有給", absence: "欠勤", special: "特別" };
const period = (r) => (r.date_from === r.date_to ? r.date_from : `${r.date_from} 〜 ${r.date_to}`);

const CONFIG = {
  title: "休み申請の承認",
  // サイドバーのハイライト用。NAV のキー(home/attendance/shift/todo/apply/payslip)と
  // 一致させる必要がある。経営者の承認の入口は勤怠履歴なので attendance に寄せる。
  active: "attendance",
  listPath: "/api/employee/leave/list",
  decidePath: "/api/employee/leave/decide",
  fields: [
    { header: "社員", value: (r) => r.employee_name, nowrap: true, primary: true },
    { header: "種別", value: (r) => TYPE_LABEL[r.type] || r.type, nowrap: true },
    { header: "期間", value: (r) => period(r), nowrap: true },
    { header: "理由", value: (r) => r.reason || "-", muted: true, wrap: true },
  ],
};

function LeaveApprovalPage() {
  return <ApprovalList config={CONFIG} />;
}

export default LeaveApprovalPage;
